import React,{ useState } from "react"
import { ProfileCorporateComponent } from "./ProfileCorporateComponent";
import { ProfilePersonalComponent } from "./ProfilePersonalComponent";
export function ProfileComponent(){
    const [profileData, setProfileData] = useState(null);

    return(
        <ProfileCorporateComponent/>
        // <>ProfileComponent</>
    )
}